import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { requestPositionClose } from "@actions/futures";
import { useOpenPositionModels } from "../positionLines/useOpenPositionModels";
import { toChartPositions } from "../positionLines/toChartPositions";

/**
 * Passes the open positions of the pair to the chart engine: entry lines
 * with the live PnL and the close button, take profit, stop loss (or
 * liquidation without it) and the zones (moon-position-lines-spec.md).
 * The "P&L lines" toggle of the «…» menu shows and hides them; ✕ closes
 * the position through requestPositionClose.
 *
 * @param {object|null} engine - ChartEngine, null until created
 * @param {string} symbol - pair slug, e.g. "BTCUSDT"
 */
const usePositionLines = (engine, symbol) => {
  const dispatch = useDispatch();
  const { models, labels, isVisible } = useOpenPositionModels(symbol);
  const positions = useMemo(() => toChartPositions(models, labels), [models, labels]);
  const closeLabel = labels.close;

  useEffect(() => {
    engine?.positions.setCloseButton({
      label: closeLabel,
      onClose: (positionId) => dispatch(requestPositionClose(positionId)),
    });
  }, [engine, dispatch, closeLabel]);

  useEffect(() => {
    engine?.positions.setVisible(isVisible);
  }, [engine, isVisible]);

  useEffect(() => {
    engine?.positions.setPositions(positions, symbol);
  }, [engine, positions, symbol]);
};

export default usePositionLines;
